import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { Container, IDestroyOptions, Rectangle, Sprite, Text, TextStyle } from "pixi.js";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";

export class WalletsTooltip extends Container {
    private static readonly TEXT = 'CONNECT EXTERNAL WALLET';

    private readonly background: Sprite;
    private readonly text: Text;
    private readonly closeButton: ButtonWithScaleAnimation;

    public constructor(commonResources: CommonResourcesPackage, myWalletResources: MyWalletResourcePackage) {
        super();
        this.background = new Sprite(myWalletResources.assets_views_my_wallet_ui_tooltip_png);
        this.text = new Text(WalletsTooltip.TEXT, new TooltipTextStyle());
        this.text.position.set((this.background.width - this.text.width) * 0.5, 62);
        this.closeButton = new ButtonWithScaleAnimation(commonResources.assets_common_x_png);
        this.closeButton.width = this.closeButton.height = 30;
        this.closeButton.position.set(477, 23);
        this.closeButton.onUp.add(this.onCloseButtonClickHandle, this);
        this.closeButton.hitArea = new Rectangle(-this.closeButton.width, -this.closeButton.height, this.closeButton.width * 3, this.closeButton.height * 3);

        this.addChild(this.background, this.text, this.closeButton);

        this.visible = false;
    }

    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }

    private onCloseButtonClickHandle(): void {
        this.hide();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.closeButton.onUp.remove(this.onCloseButtonClickHandle, this);
        super.destroy(options);
    }
}

class TooltipTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36,
            fill: 'FFFFFF',
            trim: true
        });
    }
}